import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import * as actions from './actions';
import { MalwareFilterPolicy } from 'projects/angular-clarity/src/app/interfaces/powershell/exo/malware-filter-policy.interface';
import { initialStatus, Status } from 'projects/angular-clarity/src/app/stores/status.interface';

export const featureKey = 'malwareFilterPolicy';
export interface State extends EntityState<MalwareFilterPolicy>, Status {}

export const adapter: EntityAdapter<MalwareFilterPolicy> = createEntityAdapter<MalwareFilterPolicy>();

export const initialState: State = adapter.getInitialState({
    ...initialStatus,
});

export const reducer = createReducer(
    initialState,
    on(actions.loadMalwareFilterPolicySuccess, (state, action) =>
        adapter.setAll(action.data, { ...state, loaded: true, error: null }),
    ),
    on(actions.loadMalwareFilterPolicyFailure, (state, { error }) => ({ ...state, error })),

    on(actions.updateExoMalwareFilterPolicy, (state) => ({ ...state, updating: true, error: null })),
    on(actions.updateExoMalwareFilterPolicySuccess, (state, action) =>
        adapter.upsertOne(action.data, { ...state, updating: false, error: null }),
    ),
    on(actions.updateExoMalwareFilterPolicyFailure, (state, { error }) => ({ ...state, updating: false, error })),
);

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
